



























import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import moment, {Moment} from 'moment';
import SearchQuotation from '@/components/searchQuotation.vue';
import { pubsub, CLOSE_TAG_VIEW_EVENT } from '@/utils/pubsub';
import { disabledDate } from '@/utils/other';

type IUpdateModuleParams = IModule.IRequest.IUpdateModuleParams;
interface IForm {
  title: string;
  due: Moment | null;
  quotationId: string;
  manDay: number;
  comment: string;
}

@Component({
  components: {
    SearchQuotation,
  },
})
export default class ModuleForm extends Vue {
  private submitLoading: boolean = false;
  private disabledDate = disabledDate;
  get formTitle() {
    if (this.isCreate) {
      return this.$t('module.createModule');
    } else {
      return this.$t('module.editModule');
    }
  }
  @Ref() private readonly moduleForm!: FormModel;
  @Ref() private readonly searchQuotation!: SearchQuotation;
  get rules() {
    return {
      title: [{ required: true, message: () => this.$t('form.required'), trigger: 'blur'}],
      due: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
      quotationId: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
      manDay: [{ required: true, message: () => this.$t('form.required'), trigger: 'blur'}],
    };
  }
  @Prop({default: true}) private isCreate!: boolean;
  @Prop({required: true}) private moduleInfo!: IUpdateModuleParams;
  @Prop({required: true}) private submit!: (
    updateInfo: IUpdateModuleParams,
  ) => Promise<string>;
  private form: IForm = {
    title: '',
    quotationId: '',
    due: moment(),
    manDay: 0,
    comment: '',
  };
  private created() {
    this.initFormData();
  }
  private initFormData() {
    const {title, quotationId, due, manDay, comment} = this.moduleInfo;
    this.form = {
      title,
      quotationId,
      due: due ? moment(due) : null,
      manDay,
      comment,
    };
    if (quotationId) {
      this.$nextTick(() => {
        this.searchQuotation.searchQuotationById(quotationId);
      });
    }
  }
  private handleSubmit() {
    this.moduleForm.validate((valid) => {
      if (valid) {
        const {title, due, quotationId, manDay, comment} = this.form;
        const dueValue = due ? due.format('YYYY-MM-DD') : '';
        const updateInfo: IUpdateModuleParams = {
          title,
          quotationId,
          due: dueValue,
          manDay,
          comment,
        };
        this.submitModule(updateInfo);
      } else {
        return false;
      }
    });
  }
  private submitModule(updateInfo: IUpdateModuleParams) {
    this.submitLoading = true;
    this.submit(updateInfo).then((res) => {
      this.$message.success(res);
    }).catch((err) => {
      this.$message.warning(err);
    }).finally(() => {
      this.submitLoading = false;
    });
  }
  private updateQuotation(quotation: ISolution.IResponse.ISolutionInfo | null) {
    if (quotation) {
      this.form.quotationId = quotation.id;
      this.form.title = quotation.title;
    } else {
      this.form.quotationId = '';
    }
  }
  private goListPage() {
    pubsub.publish(CLOSE_TAG_VIEW_EVENT, this.$route.path);
    this.$router.push({
      name: 'Module',
    });
  }
}
